import React from "react";

import Sponsor from "../../../components/Sponsor/Sponsor";
import Banner from "../../../sections/Banner/Banner";
import Button from "../../../components/Button/Button";

import "./Sponsors.css";

const sponsors = () => {
  return (
    <React.Fragment>
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/gear-wide.jpg"
        img_alt="Gear"
      >
        <h1>Sponsors</h1>
      </Banner>

      <section>
        <p className="text-md">
          District Track is powered by a team of organizations and industry
          professionals that display unparalleled expertise in their respective
          sectors
        </p>

        <Sponsor
          img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/logos/UA-black.png"
          img_alt="Under Armour"
          sponsorType="title"
        >
          <p>
            Under Armour is a leader in athletic innovation and has worked
            closely with our organization to promote the growth of track
            programming in the DC Metro area.
          </p>
          <Button to="https://www.underarmour.com" buttonType="Black">
            Learn More
          </Button>
        </Sponsor>

        <div className="Sponsors">
          <Sponsor
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/assets/media/partners/inside-tracker-logo.png"
            img_alt="Inside Tracker"
          >
            <p>
              <span className="b">Inside Tracker</span> is our premier resource
              for nutritional support offering personalized recommendations for
              healthy eating, living, and supplementation.
            </p>
            <Button
              to="https://www.insidetracker.com/"
              buttonType="Black"
              size="sm"
            >
              Learn More
            </Button>
          </Sponsor>

          <Sponsor
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/logos/rollrecovery.png"
            img_alt="Roll Recovery"
          >
            <p>
              <span className="b">Roll Recovery</span> creates thoughtfully
              designed products to keep you moving, wherever your path might
              take you. Their products are our go-to recovery tools and a
              must-have for recovering between workouts.
            </p>
            <Button to="https://rollrecovery.com/" buttonType="Black" size="sm">
              Learn More
            </Button>
          </Sponsor>

          <Sponsor
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/assets/media/partners/captiol-rehab.png"
            img_alt="Capitol Rehab"
          >
            <p>
              <span className="b">Capitol Rehab</span> is our primary source for
              Chiropractic Care. They specialize in treating athletes and have
              provided exceptional chiropractic services to our team since 2018.
            </p>
            <Button
              to="https://capitolrehabofarlington.com/"
              buttonType="Black"
              size="sm"
            >
              Learn More
            </Button>
          </Sponsor>

          <Sponsor
            img_src="https://districttrack.s3.us-east-2.amazonaws.com/assets/media/partners/Resurgent.png"
            img_alt="Resurgent Sports Rehab"
          >
            <p>
              <span className="b">Resurgent Sport Rehab</span> keeps our team
              healthy and strong as metro DC's only Immediate Care & Rehab
              Center led by Doctors of Physical Therapy that specialize in
              running related injuries.
            </p>
            <Button
              to="https://resurgentsports.com/"
              buttonType="Black"
              size="sm"
            >
              Learn More
            </Button>
          </Sponsor>

          <Sponsor
            img_src="https://s3.us-east-2.amazonaws.com/districttrack/assets/media/partners/growing-runners-transparent.png"
            img_alt="Growing Runners"
          >
            <p>
              <span className="b">Growing Runners</span> is a key partner in
              helping our organization develop educational resources and
              mentorship support for serious high school athletes.
            </p>
            <Button
              to="https://growingrunners.com/"
              buttonType="Black"
              size="sm"
            >
              Learn More
            </Button>
          </Sponsor>
        </div>
      </section>
    </React.Fragment>
  );
};

export default sponsors;
